//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import InstagramFeed from './InstagramFeed.vue'
import FacebookFeed from './FacebookFeed.vue'
import YoutubeFeed from './YoutubeFeed.vue'

export default {
  data: function() {
    return {
      
    };
  },
  components: {
      InstagramFeed,
      FacebookFeed,
      YoutubeFeed,
  },
};



// WEBPACK FOOTER //
// ./scripts/vue/SocialApp.vue